import axios from "axios";
import { API_URL } from "../utils/Constant";
import { getUser } from "../utils/helpers";

export const updateHmcData = async (genista_id, result) => {
  try {
    const response = await axios.post(`${API_URL}/hmcresults/`, {
      test_name: "HMC",
      list: [
        {
          genista_id,
          result,
        },
      ],
      user_id: getUser()?.id,
    });

    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = e?.response?.data?.message || "Something went wrong.";
    return { success: false, message };
  }
};

export const getHmcData = async () => {
  try {
    const response = await axios.get(`${API_URL}/gethmc/`);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong." };
  }
};

// eslint-disable-next-line no-unused-vars
export const bioChemMerge = async (payload, signal = null) => {
  try {
    let response = await axios.get(
      `${API_URL}/biochemresults/`, { params: { date: payload.date }, signal },
    );
    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message, canceled: e.code === "ERR_CANCELED" };
  }
};
